import React from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';

const ConfirmExit = (props) => (
  <Modal
    destructiveModal
    title="Discard Changes"
    message="Are you sure? This will remove any new changes you have made."
    onClickPrimary={props.onClickPrimary}
    onClickCancel={props.onClickCancel}
    primaryButtonText="Yes, discard changes"
    cancelButtonText="No, keep editing"
  />
);

ConfirmExit.propTypes = {
  onClickCancel: PropTypes.func,
  onClickPrimary: PropTypes.func,
};

ConfirmExit.defaultProps = {
  onClickCancel: () => {},
  onClickPrimary: () => {},
};

export default ConfirmExit;
